<template>
  <div class="marketBox">
    <div class="head">
      <div class="head-name">名称</div>
      <div>分时预览</div>
      <div>实时价</div>
      <div>回收价</div>
      <div>涨跌幅</div>
    </div>
    <div class="main">
      <div
        class="col"
        v-for="(item, index) in marketData"
        :key="index"
        @click="goKLine(item.id)"
      >
        <div class="name">{{ item.metalName }}</div>
        <div :id="item.id" class="pic"></div>
        <div
          :class="{
            price: true,
            priceFall: item.amount < 0,
            priceRise: item.amount > 0,
          }"
        >
          {{ item.price }}
        </div>
        <div class="recyclingPrice price">{{ item.recyclingPrice }}</div>
        <div class="rf">
          <div
            class="top"
            :style="{
              background: item.amount < 0 ? '#20AF91' : '#FF5D58',
            }"
          >
            {{ item.percentage }}%
          </div>
          <div
            :class="{
              bottom: true,
              priceFall: item.amount < 0,
              priceRise: item.amount > 0,
            }"
          >
            {{ item.amount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["marketData"],
  data() {
    return {};
  },
  created() {
    this.marketData.map((item) => {
      const fixArray = ["price", "salePrice", "recyclingPrice", "percentage"];

      fixArray.map((item2) => {
        item[item2] = item[item2] !== null ? item[item2].toFixed(2) : 0;
        if (
          item2 == "percentage" &&
          item["percentage"] < 0.01 &&
          item["percentage"] > 0
        ) {
          item[item2] = "<0.01";
        }
      });
    });
  },
  mounted() {
    this.marketData.map((item) => {
      this.printLine(item);
    });
  },

  methods: {
    goKLine(id) {
      this.$emit("setScroll");
      this.$router.push({ path: "kLine", query: { id: id } });
    },
    printLine(param) {
      const line = document.getElementById(param.id);
      const lineChart = this.$echarts.init(line);
      const option = {
        xAxis: {
          type: "category",
          data: param.lineData.slice(0, 200),
          show: false,
        },
        yAxis: {
          type: "value",
          min: function (value) {
            return value.min;
          },
          max: function (value) {
            return value.max;
          },
          show: false,
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        series: [
          {
            markLine: {
              symbol: "none",
              data: [
                {
                  yAxis: param.price,
                },
                {
                  yAxis: 0.466,
                },
              ],
              lineStyle: {
                color: "#c9c9c9",
                width: 1.2,
              },
              label: {
                show: false,
                position: "end",
                formatter: "{b}",
              },
            },
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 2,
                  colorStops: [
                    {
                      offset: 0,
                      color:
                        param.amount < 0
                          ? "rgba(32, 175, 145, 1)"
                          : "rgba(255, 93, 88, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 0.7,
                      color: "#fff", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
            data: param.lineData,
            smooth: true,
            type: "line",
            symbol: "none",
            itemStyle: {
              color:
                param.amount < 0
                  ? "rgba(32, 175, 145, 1)"
                  : "rgba(255, 93, 88, 1)",
            },
          },
        ],
      };
      lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.marketBox {
  width: 100%;
  .head {
    margin: 32px 0;
    width: 646px;
    height: 37px;
    display: flex;
    justify-content: space-between;
    > div {
      color: rgba(102, 102, 102, 1);
      font-size: 26px;
      width: 107px;
      text-align: center;
    }
    .head-name {
      width: 150px;
    }
  }
  .main {
    .col {
      width: 646px;
      height: 67px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(237, 237, 237, 1);
      padding: 10px 0;
      > div {
        width: 104px;
        text-align: center;
      }
      .name {
        color: rgba(51, 51, 51, 1);
        font-size: 26px;
        line-height: 67px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        padding-left: 20px;
        box-sizing: border-box;
        width: 150px;
      }
      .pic {
        width: 104px !important;
        height: 67px !important;
        width: 104px;
        line-height: 67px;
      }
      .price {
        font-size: 26px;
        line-height: 67px;
        width: 104px;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .rf {
        width: 112px;
        line-height: 67px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .top {
          width: 104px;
          height: 30px;
          background: #20af91;
          opacity: 1;
          border-radius: 5px;
          font-size: 22px;
          font-weight: 400;
          line-height: 36px;
          text-align: center;
          color: #ffffff;
        }
        .bottom {
          width: 104px;
          height: 30px;
          background: #ffffff;
          opacity: 1;
          border-radius: 5px;
          text-align: end;
          font-size: 18px;
          font-weight: 400;
          line-height: 36px;
        }
      }
    }
  }
}

.priceFall {
  color: #20af91;
}
.priceRise {
  color: #ff5d58;
}
</style>
